import React, { memo } from 'react';
import { SxProps, Theme, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { getGiftProduct } from '../../../store/data/data.selectors';
import { getGiftActionFlow, getProductCountry } from '../../../store/recipient.selectors';
import { GiftActionFlow } from '../../../../../store/types/GiftActionFlow.types';
import { getDetectedCountry } from '../../../../../store/geoIpCountry/geoIpCountry.selectors';
import ProductPreview from '../../../../../components/ProductPreview';

const styles: { [className: string]: SxProps<Theme> } = {
  detectedCountry: {
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 'bold',
    opacity: 0.7,
    color: 'text.primary',
  },
};

const GiftProductPreview = (): JSX.Element => {
  const product = useSelector(getGiftProduct);
  const productCountry = useSelector(getProductCountry);
  const giftActionFlow = useSelector(getGiftActionFlow);
  const detectedCountry = useSelector(getDetectedCountry);

  const isProductAvailable = giftActionFlow === GiftActionFlow.giftCountry;

  return (
    <ProductPreview
      name={product.name}
      image={product.image}
      provider={product.provider}
      hasExternalFulfillment={product.hasExternalFulfillment}
      available={isProductAvailable}
      country={productCountry}
      unavailableText={
        <Typography sx={styles.detectedCountry}>This gift isn’t available in {detectedCountry?.name}</Typography>
      }
    />
  );
};

export default memo(GiftProductPreview);
